import { EditorOptions } from 'tinymce';
import {
  Extension,
  RegisterExtensionEditorSetup,
  RegisterExtensionRender,
} from '../types/registerExtension';
import { quotationExtension } from './quotation/quotation.extension';

const EXTENSIONS: Extension[] = [quotationExtension];

export const DEFAULT_EXTENSIONS_RENDERS: RegisterExtensionRender[] =
  EXTENSIONS.map((el) => el.render);

export const DEFAULT_EXTENSIONS_EDITORSETUP: RegisterExtensionEditorSetup[] =
  EXTENSIONS.map((el) => el.setup);

export const DEFAULT_EXTENSIONS_EDITORFORMAT: EditorOptions['formats'] =
  EXTENSIONS.reduce((f, c) => {
    return { ...f, ...c.format };
  }, {} as EditorOptions['formats']);
